import { fromJS, Map } from 'immutable'

import { GET_ASSIGNMENTS } from './assignmentsConstants'

const assignmentsReducers = {
  [GET_ASSIGNMENTS]: ($$state: Map<string, any>, action: AssignmentReducerAction) => {
    $$state = $$state.setIn(['assignments', 'data'], fromJS(action.data))
    return $$state
  },
}

export default assignmentsReducers

type AssignmentReducerAction = {
  data?: unknown
}
